import httpClient from "./http-client";
import authHeader from "./auth-header";
import { AxiosRequestHeaders } from "axios";

const getDefaultEmailTemplate = async (): Promise<any> => {
  const { data } = await httpClient.get(`/b-client/v1/email-template/default`, {
    headers: authHeader() as AxiosRequestHeaders,
  });

  return data;
};

const setDefaultEmailTemplate = async (id: string): Promise<any> => {
  const { data } = await httpClient.put(
    `/b-client/v1/email-template/${id}/default`,
    null,
    {
      headers: authHeader() as AxiosRequestHeaders,
    }
  );

  return data;
};

const getEmailTemplates = async (page = 1, size = 10): Promise<any> => {
  const params = {
    page,
    size,
  };

  const { data } = await httpClient.get("/b-client/v1/email-template", {
    params,
    headers: authHeader() as AxiosRequestHeaders,
  });

  return data;
};

const getEmailTemplate = async (id: string): Promise<any> => {
  const { data } = await httpClient.get(`/b-client/v1/email-template/${id}`, {
    headers: authHeader() as AxiosRequestHeaders,
  });

  return data;
};

const createEmailTemplate = async (req: any): Promise<any> => {
  const { data } = await httpClient.post("/b-client/v1/email-template", req, {
    headers: authHeader() as AxiosRequestHeaders,
  });

  return data;
};

const saveEmailTemplate = async (req: any): Promise<any> => {
  const { data } = await httpClient.put("/b-client/v1/email/template", req, {
    headers: authHeader() as AxiosRequestHeaders,
  });

  return data;
};

const updateEmailTemplate = async (id: string, req: any): Promise<any> => {
  const { data } = await httpClient.put(
    `/b-client/v1/email-template/${id}`,
    req,
    {
      headers: authHeader() as AxiosRequestHeaders,
    }
  );

  return data;
};

const deleteEmailTemplate = async (id: string): Promise<any> => {
  const { data } = await httpClient.delete(
    `/b-client/v1/email-template/${id}`,
    {
      headers: authHeader() as AxiosRequestHeaders,
    }
  );

  return data;
};

export default {
  getDefaultEmailTemplate,
  setDefaultEmailTemplate,
  createEmailTemplate,
  saveEmailTemplate,
  getEmailTemplates,
  getEmailTemplate,
  updateEmailTemplate,
  deleteEmailTemplate,
};
